export default {
  Confirm: '确定',
  Cancel: '取り消し',
  'The minimum time length is xxxs!': '時間の長さは最小{{num}}sです！',
  'The maximum time length is 50s!': '時間の長さは最大50sです！',
  'Online service, no download required': 'オンラインサービス、ダウンロードは不要です',
  'Add up to 20MB file': '最大20MBのファイルを追加',
  'Support common formats': '一般的なフォーマットに対応',
  'Best for general editing requirements': '一般的な編集要件に最適です',
  '0 second wait': '待ち時間無し',
  'No size limits': 'サイズ制限なし',
  'Support 1000+ formats': '1000以上のフォーマットに対応',
  'Stable processing': '安定した処理',
  'Get access to HitPaw Toolkit!': 'HitPawツールキットをご利用いただけます。',
  'Support cut, crop & rotate, adjust, speed, add music, stop motion, etc.':
    'カット、クロップ＆回転、調整、スピード、音楽追加、ストップモーションなどをサポートします',
  'The easiest video editing software for beginners':
    '初心者のための最も簡単なビデオ編集ソフトウェア',
  'Remove watermark from videos and images in simple clicks':
    '簡単なクリックで動画や画像からウォーターマークを削除します',
  'TRY IT FREE': '無料お試し',
  'BUY NOW': '今すぐ購入',
  'Analyzing successfully! Your file is larger than 100 MB which cannot be edited by HitPaw Online, please ':
    '解析が完了しました。ファイルのサイズが100MB以上のため、HitPawオンラインでは編集できません。',
  'download the video': '動画をダウンロードし',
  'and then use HitPaw Toolkit to proceed.': '、HitPawツールキットを使って編集してください。',
  'Cut 10 video fragments at most. Get HitPaw Toolkit for more features.':
    '最大 10 個のビデオフラグメントをカットする。その他の機能については、HitPawToolkitを入手してください。',
  'Max file size for videos is 20 MB. Get HitPaw Toolkit for big file.':
    'ファイルのサイズは20MBまでです。その他の機能については、HitPawToolkitを入手してください。',
  'The minimum time length is 1s! Get HitPaw Toolkit for more features.':
    '時間の長さは最小1sです！その他の機能については、HitPawToolkitを入手してください。',
  'Add 3 videos at most. Get HitPaw Toolkit for more features.':
    'ビデオ 3 個を最大限に追加する。その他の機能については、HitPawToolkitを入手してください。',
  'This format is not supported currently.': 'このファイル形式は現在サポートされていません。',
  'This format is not supported currently. Get HitPaw Toolkit for more formats':
    'このファイル形式は現在サポートされていません。その他の機能については、HitPawToolkitを入手してください。',
  'Processing failed. Get HitPaw Toolkit for stable processing.': '動画の作成に失敗しました！',
  'Failed to load!  Get HitPaw Watermark Remover for stable processing.':
    '読み込みに失敗しました！',
  'Are you sure you want to delete it?': '消去してもよろしいですか？',
  'Failed to extract the audio!': '音声の抽出に失敗しました！',
  'Coming Soon': '近日公開',
  'Learn more': 'より詳しく見る',
  'Add up to 2 files. Get HitPaw Toolkit for big file.':
    '最大2ファイルまで追加できます。 その他の機能については、HitPawToolkitを入手してください。',
  Download: 'ダウンロードする',
  'Try Again': 'もう一度試す',
  Failed: '失敗しました',
  'Get Started': '編集開始',
  Start: '開始',
  End: '終了',
  Export: 'エクスポート',
  'Your audio is ready!': '音声データの準備は完了しています！',
  'Download Audio': '音声データをダウンロードする',
  YES: 'はい',
  'Export Failed': '転送失敗',
  'Error occurs, the file cannot be added': 'エラーが起こったため、そのファイルは追加されません。',
  'Support merging audio files at most': '最大{{num}}つの音声データファイルを結合することを助ける',
  'Are you sure you want to delete this task?': '本当にこのタスクを削除しますか？',
  Processing: '処理中です',
  "Don't forget to download your file, it will be deleted after 24 hours.":
    'ファイルのダウンロードをお忘れなく。24時間後にはファイルは廃棄されてしまいます。',
  Uploading: 'アップロード中',
  'Go Edit': '編集する',
  'Generate Files Successfully!': 'ファイルの作成に成功しました！',
  'Your order is being paid...': 'あなたの注文は支払われています',
  'Not yet': 'まだ',
  'Payment completed': 'はい',
  downloadFail: 'Failed to download, please try again.',
  videoReady: 'Your animated photo is ready!',
  'Download Without Watermark': 'Download Without Watermark',
  'Download As GIF': 'Download As GIF',
  'Download With Watermark': 'Download With Watermark',
  'Upload New Photo': 'Upload New Photo',
  ///////////
  'Upgrade to access HitPaw Online Pro Features.': 'Upgrade to access HitPaw Online Pro Features.',
  'Free account cannot upload image size that exceeds 2M.':
    'Free account cannot upload image size that exceeds 2M.',
  'Free account cannot upload more than 6 images.':
    'Free account cannot upload more than 6 images.',
  'No Image Size Limits': 'No Image Size Limits',
  'Unlimited Image Uploads': 'Unlimited Image Uploads',
  'Download HD Image with No Watermark': 'Download HD Image with No Watermark',
  'Download Video as GIF': 'Download Video as GIF',
  'More Privileges': 'More Privileges',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  'Cancel auto-renewable subscription anytime.': 'Cancel auto-renewable subscription anytime.',
  'Login to Start': 'Login to Start',
  'Buy Now': 'Buy Now',
  'Network Error': 'Network Error',
  'Connection server failed.': 'Connection server failed.',
  Month: 'Month',
  priceMonth: '$9.99',
  priceYear: '$4.99',
  'HitPaw Video Converter': 'HitPaw Video Converter',
  'The upload video size cannot exceed 20MB. Download HitPaw Video Converter for more features.': 'The uploaded video size cannot exceed 20MB. Download HitPaw Video Converter for more features.',
  'The upload video size cannot exceed 500MB. Download HitPaw Video Converter for more features.': 'The uploaded video size cannot exceed 500MB. Download HitPaw Video Converter for more features.',
  'The upload image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.':  'The uploaded image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.',
  'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.': 'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.',
  'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.': 'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.',
  'Download desktop version to batch process large files with no size limit': 'Download desktop version to batch process large files with no size limit',
  'Batch convert video and audio files to 1000+ formats with 120X faster speed': 'Batch convert video and audio files to 1000+ formats with 120X faster speed',
  'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.': 'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.',
  'Built-in rich video editing features: merge, cut, crop, watermark, etc.': 'Built-in rich video editing features: merge, cut, crop, watermark, etc.',
  'Convert Apple Music to MP3 with DRM removed (Windows version only)': 'Convert Apple Music to MP3 with DRM removed (Windows version only)',
}
